// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fullsize[data-v-f79855b2]{height:100vh;width:100vw}.loading-spinner[data-v-f79855b2]{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.loadingBar[data-v-f79855b2]{position:absolute;bottom:30px}", ""]);
// Exports
module.exports = exports;
